import { accountRegister, accountRegister2 } from '@/services/account'
import rules from './rules'
export default {
  namespaced: true,
  state: {
    submitting: false,
    decorators: {
      mobile: ['mobile', { rules: rules.tel }],
      checkcode: ['checkcode', { rules: rules.validCode }],
      username: ['username', { rules: rules.username }],
      password: ['password', { rules: rules.password }],
      truename: ['truename', { rules: rules.truename }]
    }
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    }
  },
  actions: {
    async register ({ commit }) {
      commit('setSubmitting', true)
      const chain = await accountRegister()
        .onSuccess((raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    async ajaxRegSecond ({ commit }) {
      commit('setSubmitting', true)
      const chain = await accountRegister2()
        .onSuccess((raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}
